// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"9046d463","621":"1056c15f","843":"8d732fc8","856":"f6b42092"}[chunkId] + ".chunk.js";
};